import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { useUploadMediaMutation } from "../service/common/api";

const EditText = (props: { content: string; setContent: (arg0: string) => void }) => {
  const [uploadMedia] = useUploadMediaMutation();
  const [editorState, setEditorState] = useState(() => {
    if (props.content && props.content.trim()) {
      const contentBlock = htmlToDraft(props.content);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        return EditorState.createWithContent(contentState);
      }
    }
    return EditorState.createEmpty();
  });
  const onEditorStateChange = (newEditorState: any) => {
    setEditorState(newEditorState);
    const text = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    if (text !== props.content) {
      props.setContent(text);
    }
  };

  useEffect(() => {
    const currentHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    // If the content from props is different from what's in the editor,
    // and it's not just a minor formatting difference, update the editor.
    // We trim to avoid issues with extra newlines.
    if (props.content !== " " && props.content?.trim() !== currentHtml?.trim()) {
      const contentBlock = htmlToDraft(props.content || "");
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        setEditorState(EditorState.createWithContent(contentState));
      }
    }
  }, [props.content]);

  // IMAGE UPLOAD FUNCTION
  const uploadImageCallBack = (file: File) => {
    return new Promise(async (resolve, reject) => {
      try {
        const formData = new FormData();
        formData.append("file", file);
        const res = await uploadMedia(formData).unwrap();
        if (res?.data) {
          resolve({ data: { link: res.data } });
        } else {
          reject(new Error("Failed to get image link from response"));
        }
      } catch (err) {
        reject(err);
      }
    });
  };

  return (
    <div>
      <Editor
        toolbar={{
          options: [
            "inline",
            "fontSize",
            "list",
            "textAlign",
            "link",
            "colorPicker",
            "image", // <-- Added
          ],
          image: {
            uploadEnabled: true,
            previewImage: true,
            alt: { present: true, mandatory: false },
            uploadCallback: uploadImageCallBack,
          },
          inline: {
            options: ["bold", "italic", "underline"],
          },
          textAlign: {
            options: ["left", "center"],
          },
          list: {
            options: ["unordered"],
          },
        }}
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        editorStyle={{
          height: "40vh",
          border: "1px solid #E6E8F0",
          padding: 10,
        }}
      />
    </div>
  );
};

export default EditText;
